import { TenantGroupCodesSelect } from '../../components/TenantGroupCodesSelect/TenantGroupCodesSelect'
import { InventorySystemTypeSelect } from '../../components/InventorySystemTypeSelect/InventorySystemTypeSelect'
import { StringListInput } from '../../components/StringListInput/StringListInput'
import type { EventRebuildFieldsProps } from './EventRebuildFields.types'

const MAX_SYS_EVENT_IDS = 10

export function EventRebuildFields({
  state,
  update,
  availableCodes,
  isLoadingGroups,
}: EventRebuildFieldsProps) {
  return (
    <div className="create-form-table">
      <div className="create-form-row">
        <div className="create-form-label">
          Event IDs
          <span className="create-form-required" aria-hidden="true">
            *
          </span>
        </div>
        <div className="create-form-input-cell">
          <StringListInput
            values={state.sysEventIds}
            onChange={(sysEventIds) => update({ sysEventIds })}
            placeholder="Add an event ID"
            addLabel="Add event"
            ariaLabel="Add event ID"
            maxItems={MAX_SYS_EVENT_IDS}
          />
        </div>
      </div>

      <div className="create-form-row">
        <div className="create-form-label">
          Inventory System Type
          <span className="create-form-required" aria-hidden="true">
            *
          </span>
        </div>
        <div className="create-form-input-cell">
          <InventorySystemTypeSelect
            value={state.inventorySystemType}
            onChange={(inventorySystemType) => update({ inventorySystemType })}
          />
        </div>
      </div>

      <div className="create-form-row">
        <div className="create-form-label">Tenant Groups (optional)</div>
        <div className="create-form-input-cell">
          <TenantGroupCodesSelect
            availableCodes={availableCodes}
            selected={state.tenantGroupCodes}
            onChange={(tenantGroupCodes) => update({ tenantGroupCodes })}
            isLoading={isLoadingGroups}
          />
        </div>
      </div>

      <div className="create-form-row--last">
        <div className="create-form-label">Force Availability Rebuild</div>
        <div className="create-form-input-cell">
          <div className="w-100">
            <input
              type="checkbox"
              className="form-check-input"
              id="rebuildFilterPrices"
              checked={state.rebuildFilterPrices}
              onChange={(e) =>
                update({ rebuildFilterPrices: e.target.checked })
              }
            />
            <label
              htmlFor="rebuildFilterPrices"
              className="rebuild-inventory-checkbox-label"
            >
              Force availability rebuild for the selected events.
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}
